import { partial } from '../../../util/translation/translation';

const p = partial('validateErrors');
const validateLotteryForm = (values) => {
  const errors = {};
  try {
    if (!values.name) {
      errors.name = p('nameFieldEmpty');
    }

    if (!values.startDate) {
      errors.startDate = p('startDateFieldCantBeEmpty');
    }

    if (values?.drawType?.value === 'automatic' && !values.endDate) {
      errors.endDate = p('endDateFieldCantBeEmpty');
    }

    const ticketPrice = Number(values.ticketPrice);
    if (!values.ticketPrice || Number.isNaN(ticketPrice) || ticketPrice <= 0) {
      errors.ticketPrice = p('enterCorrectPrice');
    }

    const winningSplitPercent = Number(values.winningSplitPercent);
    if (
      values.winningSplitPercent === undefined ||
      values.winningSplitPercent === null ||
      values.winningSplitPercent === '' ||
      Number.isNaN(winningSplitPercent) ||
      winningSplitPercent < 0 ||
      winningSplitPercent > 100
    ) {
      errors.winningSplitPercent = p('enterCorrectVat');
    }

    const maxPrizePerWinner = Number(values.maxPrizePerWinner);
    if (
      !values.maxPrizePerWinner ||
      Number.isNaN(maxPrizePerWinner) ||
      maxPrizePerWinner <= 0
    ) {
      errors.maxPrizePerWinner = p('enterCorrectPrice');
    }

    if (!values.drawType) {
      errors.drawType = p('missingVendorValue');
    }

    if (!values.type) {
      errors.type = p('missingTeamId');
    }
    return errors;
  } catch (err) {
    console.log(err);
    return errors;
  }
};
export default validateLotteryForm;
